export enum ModalHeight {
  MAX = '100%',
  MIDDLE = '49.38%',
  SMALL = '25%',
}

export enum Directions {
  DOWN = 'down',
  UP = 'up',
  RIGHT = 'right',
  LEFT = 'left',
}

export enum FullScreenModalType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface ModalButtonProps {
  title: string;
  onPress: () => void;
}
